import { render, staticRenderFns } from "./EmailSettingAccountNotSynced.vue?vue&type=template&id=0108a2bf&scoped=true&"
import script from "./EmailSettingAccountNotSynced.vue?vue&type=script&lang=js&"
export * from "./EmailSettingAccountNotSynced.vue?vue&type=script&lang=js&"
import style0 from "./EmailSettingAccountNotSynced.vue?vue&type=style&index=0&id=0108a2bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0108a2bf",
  null
  
)

export default component.exports